var render = function (_h,_vm) {var _c=_vm._c;return _c('v-progress-circular',{class:{ 'progress-circular--hide': !_vm.props.loading },attrs:{"indeterminate":"","size":74,"width":4,"color":"accent"}},[_c('v-btn',{attrs:{"fab":"","type":_vm.props.type,"color":"primary","dark":!_vm.props.loading,"light":_vm.props.loading,"disabled":_vm.props.loading},on:{"click":function($event){_vm.listeners.click || null}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4051fe90","hasScoped":true,"optionsId":"0","buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBtn.vue
// module id = null
// module chunks = 